import { useEffect, useState } from "react";
import { generalErrorAlert } from "../../../commons/GeneralErrorAlert";
import { getMeta } from "./api";

/** Customers, projects, offers, suppliers, warranties and the user's rights for the module. */
const useMeta = () => {
  const [meta, setMeta] = useState(null);
  const load = () =>
    getMeta()
      .then(res => setMeta(res.data))
      .catch(generalErrorAlert);
  useEffect(() => {
    load();
  }, []);
  return [meta, load];
};

export default useMeta;
